import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

import { Button } from "@icg360/design-system";

import { ErrorMessage } from "components/error-message";
import { captureException, isLoggedIn, logout } from "utils";

import styles from "./full-page-error.module.scss";

const FullPageError = () => {
  const error = useRouteError();

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <ErrorMessage>
      {isLoggedIn() ? (
        <Button
          appearance="secondary"
          size="sm"
          className={styles.logoutButton}
          onPress={() => logout()}
          data-testid="logout-btn"
        >
          Log out
        </Button>
      ) : null}
    </ErrorMessage>
  );
};

export default FullPageError;
